import { ArrowUpRight, Mail, UserPlus } from "lucide-react";

export default function Contact() {
    return (
        <section
            id="contact-section"
            data-testid="contact-section"
            className="section-y bg-[#F8F9FA]"
        >
            <div className="container-x">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <p className="text-xs uppercase tracking-[0.2em] text-signal font-bold mb-4">
                            — Inscription & Contact
                        </p>
                        <h2 className="font-display font-black tracking-tighter text-ink text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
                            Rejoignez-nous
                            <br />
                            ou parlons-en.
                        </h2>
                        <p className="mt-6 text-slate-600 text-lg leading-relaxed">
                            L'inscription se fait directement sur la
                            plateforme Carvaelis. Pour toute question, notre
                            service assistance est disponible par email.
                        </p>

                        <div className="mt-12 space-y-6 border-t border-slate-200 pt-8">
                            <div>
                                <div className="text-xs uppercase tracking-wider text-slate-500 mb-1">
                                    Disponibilité
                                </div>
                                <div className="font-display font-bold text-xl text-ink">
                                    7j / 7 — 8h à 22h
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-slate-200 border border-slate-200">
                        {/* Card 1 — Inscription */}
                        <div className="bg-white p-8 lg:p-10 flex flex-col group hover:bg-ink transition-colors duration-500">
                            <div className="w-12 h-12 bg-signal flex items-center justify-center mb-8">
                                <UserPlus
                                    className="w-6 h-6 text-white"
                                    strokeWidth={2}
                                />
                            </div>
                            <h3 className="font-display font-black text-2xl sm:text-3xl tracking-tight text-ink group-hover:text-white transition-colors mb-3">
                                Inscription
                            </h3>
                            <p className="text-slate-600 group-hover:text-white/70 transition-colors leading-relaxed flex-1 mb-8">
                                Que vous soyez client ou convoyeur,
                                l'inscription s'effectue exclusivement sur
                                la plateforme Carvaelis. Aucun formulaire à
                                remplir ici.
                            </p>
                            <a
                                href="https://carvaelis.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-platform-cta"
                                className="inline-flex items-center justify-between gap-3 border-2 border-ink group-hover:border-signal text-ink group-hover:text-signal hover:bg-signal hover:!text-white hover:!border-signal px-6 py-4 font-bold uppercase tracking-wider text-sm transition-colors"
                            >
                                Accéder à la plateforme
                                <ArrowUpRight className="w-4 h-4" />
                            </a>
                        </div>

                        {/* Card 2 — Assistance */}
                        <div className="bg-white p-8 lg:p-10 flex flex-col group hover:bg-ink transition-colors duration-500">
                            <div className="w-12 h-12 bg-ink group-hover:bg-signal transition-colors flex items-center justify-center mb-8">
                                <Mail
                                    className="w-6 h-6 text-white"
                                    strokeWidth={2}
                                />
                            </div>
                            <h3 className="font-display font-black text-2xl sm:text-3xl tracking-tight text-ink group-hover:text-white transition-colors mb-3">
                                Service assistance
                            </h3>
                            <p className="text-slate-600 group-hover:text-white/70 transition-colors leading-relaxed flex-1 mb-8">
                                Une question, un besoin spécifique ?
                                Contactez directement notre équipe par
                                email — nous vous répondons sous 24h.
                            </p>
                            <a
                                href="mailto:assistance@carvaelis.com?subject=Demande%20d'information%20Carvaelis"
                                data-testid="contact-assistance-email"
                                className="inline-flex items-center justify-between gap-2 bg-signal hover:bg-signal-dark text-white px-4 py-4 font-bold text-[13px] transition-colors group/email"
                            >
                                <span className="flex items-center gap-2 min-w-0">
                                    <Mail className="w-4 h-4 flex-shrink-0" />
                                    <span className="normal-case tracking-normal">
                                        Contacter l'assistance
                                    </span>
                                </span>
                                <ArrowUpRight className="w-4 h-4 group-hover/email:translate-x-1 group-hover/email:-translate-y-1 transition-transform flex-shrink-0" />
                            </a>
                            <p className="mt-3 text-xs text-slate-500 group-hover:text-white/50 transition-colors">
                                Cliquez pour ouvrir votre messagerie.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
